"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ApiClient = void 0;
const exceptions_1 = require("../exceptions/exceptions");
const avp_models_1 = require("@oneaudi/avp-models");
const types_1 = require("../types/types");
const domainName = 'dga.avp.tech';
class ApiClient {
    constructor(stage, brand) {
        const domain = ApiClient.getDomainName(stage);
        this.endpoint = `https://api.${domain}`;
        this.brandName = ApiClient.toBrandName(brand);
    }
    static getDomainName(stage) {
        return stage === types_1.Stage.PROD
            ? domainName
            : stage === types_1.Stage.TEST
                ? `${types_1.Stage.TEST}.${domainName}`
                : `${types_1.Stage.DEV}.${domainName}`;
    }
    static toBrandName(brand) {
        switch (brand) {
            case avp_models_1.Brand.SEAT:
                return 'cupra';
            case avp_models_1.Brand.AUDI:
                return 'audi';
            case avp_models_1.Brand.VW:
                return 'vw';
        }
        throw new Error(`Brand is unsupported.`);
    }
    async getOrder(id) {
        return this.doApiCall('GET', `${this.endpoint}/v1/intern/brands/${this.brandName}/giveaways/${id}`);
    }
    async doApiCall(method, url, idToken, dto) {
        try {
            const res = await ApiClient.callApi(method, url, idToken, dto);
            return ApiClient.handleSuccessResponse(res);
        }
        catch (e) {
            console.error(e);
            throw e;
        }
    }
    static async callApi(method, url, idToken, dto) {
        const headers = ApiClient.createHeaders(idToken);
        return fetch(url, {
            method,
            headers,
            ...(dto ? { body: JSON.stringify(dto) } : {})
        });
    }
    static createHeaders(idToken, contentType = 'application/json') {
        const headers = {};
        headers['Content-Type'] = contentType;
        if (idToken) {
            headers['Authorization'] = `Bearer ${idToken}`;
        }
        return headers;
    }
    static async handleSuccessResponse(res) {
        if (res.ok) {
            return res.json();
        }
        return ApiClient.handleFailureResponse(res);
    }
    static async handleFailureResponse(res) {
        const body = await res.json();
        switch (body.error) {
            case 'ValidationError':
                throw new exceptions_1.ValidationError();
            case 'UnauthorizedError':
                throw new exceptions_1.UnauthorizedError();
            case 'ItemNotFoundError':
                throw new exceptions_1.ItemNotFoundError();
            default:
                throw new Error(res.statusText);
        }
    }
}
exports.ApiClient = ApiClient;
